export default __webpack_public_path__ + "static/01_govern-12c2be8bb4205a2b038663a50c94a1e6.mp4";